export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getUsersList: state => {
        // Return tasks list
        return state.users;
    },

    /**
     * Get user by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getUserByID: state => (id) => {
        // Return user list
        return state.users[id];
    },

    /**
     * Get user name
     * @param state
     * @returns {default.campaigns|{}}
     */
    getUserNameID: state => (id) => {
        let usr = state.users[id];
        // Return user list
        return usr ? (usr.first_name+' '+usr.second_name) : "n/a";
    }

}
